import { FeedBackMessage } from '@artprov/design-system'
import PropTypes from 'prop-types'

export const GrillaSinResultados = ({ icon, iconStyles, title, titleStyles, description, descriptionStyles = '' }) => (
  <div className="w-full flex items-center justify-center flex-col mt-2">
    <div className="flex w-80 items-center">
      <FeedBackMessage
        {...(icon && { icon })}
        {...(iconStyles && { iconStyles })}
        {...(title && { title })}
        {...(titleStyles && { titleStyles })}
        {...(description && { description })}
        {...(descriptionStyles && { descriptionStyles })}
      />
    </div>
  </div>
)

GrillaSinResultados.propTypes = {
  icon: PropTypes.string,
  iconStyles: PropTypes.string,
  title: PropTypes.string,
  titleStyles: PropTypes.string,
  description: PropTypes.string,
  descriptionStyles: PropTypes.string,
}
